import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-issue-tclist-print',
  templateUrl: './issue-tclist-print.component.html',
  styleUrls: ['./issue-tclist-print.component.css']
})
export class IssueTCListPrintComponent implements OnInit {
  FilterStudentAdmissionModel = {
    StudentNo: '',
    ClassID: 0,
    SectionID: 0,
    ParentID: 0,
    RegistrationNumber: '',
    FirstName: '',
    ToDate: '',
    FromDate: '',
    TCNo: 0,
    StudentStatus: "",
    Print: ""
  };
  constructor(private activatedRoute: ActivatedRoute, private financeService: FinanceService, private studentService: StudentService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.FilterStudentAdmissionModel.SectionID = params['SectionID'];
      this.FilterStudentAdmissionModel.StudentStatus = params['StudentStatus'];
      this.FilterStudentAdmissionModel.ParentID = params['ParentID'];
      this.FilterStudentAdmissionModel.ClassID = params['ClassID'];
      this.FilterStudentAdmissionModel.StudentNo = params['StudentNo'];
      // this.FilterStudentAdmissionModel.FirstName = params['FirstName'];
      this.FilterStudentAdmissionModel.RegistrationNumber = params['RegistrationNumber'];
      this.FilterStudentAdmissionModel.ToDate = params['ToDate'];
      this.FilterStudentAdmissionModel.FromDate = params['FromDate'];
      this.FilterStudentAdmissionModel.TCNo = params['TCNo'];

      this.GetAllIssueTC()
    });
  }
  sortingOrder = 0;
  groupedItems = [];
  itemsPerPage = 6;
  currentPage = 0;
  query = '';
  pagedItems = [];
  search(itemlist) {

    for (var i = 0; i < itemlist.length; i++) {
      if (i % this.itemsPerPage === 0) {
        this.pagedItems[Math.floor(i / this.itemsPerPage)] = [itemlist[i]];
      } else {
        this.pagedItems[Math.floor(i / this.itemsPerPage)].push(itemlist[i]);
      }
    }

  }
  IssueTCList: any;
  GetAllIssueTC() {
    this.spinnerService.show();

    this.FilterStudentAdmissionModel.Print = '';
    this.studentService.GetAllIssueTC(JSON.stringify(this.FilterStudentAdmissionModel)).subscribe((response) => {
      this.IssueTCList = response.IssueTCList;
      this.search(this.IssueTCList);
      this.spinnerService.hide()

      setTimeout(() => {
        window.print();
      }, 200);

    })
  }

  ngOnInit() {
  }

}
